// Bewusst auf genau vier Rollen reduziert (Bereinigung von Altlasten aus der ursprünglichen,
// an die Entra-ID-Enterprise-App angelehnten Rollenliste "Administrator/Analyst/Planer/Leser").
// "Analyst" und "Leser" wurden entfernt: ihre Berechtigungen sind entweder bereits vollständig in
// "Administrator" enthalten (Analyst: import:write/ai:run/assignments:write/bm:read-all) oder waren
// ein reiner Lese-Grundzugang ohne eigenständigen fachlichen Zweck (Leser). Siehe
// docs/admin-guide.md Abschnitt "Rollen und Rechte" für die vollständige Dokumentation sowie die
// Migration 20260802000000_consolidate_roles für die Bereinigung bestehender Zuweisungen.
export const APP_ROLES = ["Administrator", "Business Executive", "Business Manager", "Planer"];
/**
 * Berechtigungsmatrix - vollständig dokumentiert in docs/admin-guide.md Abschnitt "Rollen und
 * Rechte" (inkl. Tabelle je Rolle) sowie im integrierten Hilfebereich (/hilfe, Abschnitt
 * "Administration: Berechtigungskonzept"). Diese Funktion ist bewusst über eigene Permission-
 * Präfixe ("bm:...") von der Themenzuordnung isoliert - die einzige Gemeinsamkeit ist die
 * Projektliste selbst.
 */
export const ROLE_PERMISSIONS = {
    Administrator: [
        "config:write",
        "import:write",
        "ai:run",
        "topics:write",
        "topics:read",
        "users:write",
        "data:delete",
        "assignments:write",
        "assignments:read",
        "planning:write",
        "planning:read",
        "export:read",
        "bm:write",
        "bm:read-all",
        "bm-target:write-all",
        "audit:read",
        "activities:read",
        "feedback:read",
        "projects:write",
        "bm-report:read-all",
        "bm-report:write-topics",
        // ActivityTimeline-Sync (Jira-Plugin) manuell ausloesen und Sync-Historie einsehen. Nur fuer
        // Administratoren - der stuendliche Cron-Job braucht dieses Recht nicht, er schreibt direkt
        // ueber Prisma.
        "activity-timeline:manage",
    ],
    Planer: ["planning:write", "planning:read", "export:read", "topics:read", "assignments:read"],
    // Sieht/bearbeitet ausschließlich die eigene Umsatzverteilung (auf Projekten, denen der Business
    // Manager bereits zugeordnet ist, bzw. neuen Projekten) und das eigene Umsatzziel - bewusst KEIN
    // export:read/topics:read/planning:read, da ein Business Manager keinen Einblick in die
    // organisationsweiten Auswertungen außerhalb seines eigenen Bereichs haben soll (siehe
    // "Jeder Benutzer darf ausschließlich die für seine Rolle vorgesehenen Daten sehen").
    // bm-report:write erlaubt ausschließlich den eigenen Bericht; die Zuordnung wird serverseitig
    // über den angemeldeten Benutzer aufgelöst, nie über eine mitgesendete Kennung. Die Themenauswahl
    // im Bericht läuft über einen eng geschnittenen eigenen Endpunkt, damit die oben begründete
    // Abgrenzung ohne topics:read bestehen bleibt.
    "Business Manager": ["bm:read", "bm:write", "bm-target:write", "projects:write", "bm-report:write"],
    // Darf alle Business Manager, deren Zielplanung, Umsätze sowie Projekt-/Themenzuordnungen
    // einsehen, darf außerdem die Zielumsätze ALLER Business Manager editieren (bm-target:write-all
    // - bewusst getrennt von bm-target:write, das nur das eigene Ziel eines Business Manager erlaubt)
    // sowie Themenzuordnungen selbst ändern (assignments:write). Darf die Umsatzverteilung selbst
    // (bm:write) NICHT bearbeiten und hat keine administrativen Rechte (kein users:write/
    // config:write/data:delete/import:write/ai:run/topics:write).
    "Business Executive": [
        "bm:read-all",
        "bm-target:write-all",
        "planning:read",
        "export:read",
        "topics:read",
        "assignments:read",
        "assignments:write",
        "activities:read",
        "projects:write",
        "bm-report:read-all",
        "bm-report:write-topics",
    ],
};
export function roleHasPermission(role, permission) {
    return ROLE_PERMISSIONS[role].includes(permission);
}
/**
 * Fachliche Rollenbezeichnung (z.B. "Business Manager") auf den Prisma-`AppRole`-Enum-Wert
 * (z.B. "BUSINESS_MANAGER") abbilden. Kein einfaches `.toUpperCase()`, da Rollennamen mit
 * Leerzeichen (z.B. "Business Manager") sonst nicht dem Enum-Bezeichner entsprechen.
 */
export const APP_ROLE_TO_PRISMA_ENUM = {
    Administrator: "ADMINISTRATOR",
    Planer: "PLANER",
    "Business Manager": "BUSINESS_MANAGER",
    "Business Executive": "BUSINESS_EXECUTIVE",
};
/** Umkehrung von APP_ROLE_TO_PRISMA_ENUM, z.B. für die Anzeige von AppUser.roles im Frontend. */
export const PRISMA_ENUM_TO_APP_ROLE = Object.fromEntries(Object.entries(APP_ROLE_TO_PRISMA_ENUM).map(([appRole, prismaEnum]) => [prismaEnum, appRole]));
